var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{attrs:{"label":_vm.label,"invalid-feedback":_vm.errorTxt,"state":_vm.state}},[_c('b-form-textarea',{attrs:{"type":_vm.type,"state":_vm.state,"rows":"row","max-rows":"maxRows","placeholder":_vm.placeholder,"readonly":_vm.readonly},model:{value:(_vm.inputVal),callback:function ($$v) {_vm.inputVal=$$v},expression:"inputVal"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }